<template>
  <div class="container flex" style="justify-content: center;position: relative;width: 100%;">
    <div class="flex" style="width: 90%;">
      <div style="width: 200px;text-align: center;">
        <img src="@/img/logo.png" alt="" style="width: 149px;height: 54px;margin-top: 40px;" v-if="isHome">
        <img src="@/img/logo.png" alt="" style="width: 110px;height: 40px;margin-top: 4px;" v-else>
      </div>
      <ul class="ul-wrapper" :class="{home: isHome}" :style="{maxWidth: isHome?'auto':'auto'}" style="flex: 1;">
        <li class="li-item" v-for="(item, index) in directory" :key="index" @click="setActive(index)">
          <router-link :to="item.link">
            <div class="son">
              <img :src="normalizeTabImage(item.imgActive)" v-show="active[index]" />
              <img :src="normalizeTabImage(item.img)" v-show="!active[index]" />
              <span :class="active[index]?'isActive':''">{{item.title}}</span>
            </div>
          </router-link>
        </li>
        <li class="li-item" @click="setActive(7)" v-show="directory.length">
          <router-link :to='"/table2?plate="+Cons.plate+"&tableName=select_api"'>
            <div class="son">
              <img :src="staticImageBase + 'sjjk_a.png'" v-show="active[7]" />
              <img :src="staticImageBase + 'sjjk.png'" v-show="!active[7]" />
              <span :class="active[7]?'isActive':''">{{'数据接口'}}</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { mapState } from "vuex";
export default {
  props: ["plate"],
  name: "tabs",
  data() {
    return {
      directory: [
        // {
        //   link: "/page/table?plate=1&tableName=select_zgypdq",
        //   img: "static/images/zonghe.png",
        //   imgActive: "static/images/zonghe_a.png",
        //   title: "产品名录",
        //   plate: 1
        // },
        // {
        //   link: "/page/table?plate=3&tableName=select_ypxscytj",
        //   img: "static/images/baogao.png",
        //   imgActive: "static/images/baogao_a.png",
        //   title: "自助报告",
        //   plate: 3
        // },
        // {
        //   link: "/page/table?plate=4&tableName=select_yplssc@1",
        //   img: "static/images/yaopin.png",
        //   imgActive: "static/images/yaopin_a.png",
        //   title: "药品零售",
        //   plate: 4
        // },
        // {
        //   link: "/page/table?plate=5&tableName=select_jcklztjk",
        //   img: "static/images/haiwai.png",
        //   imgActive: "static/images/haiwai_a.png",
        //   title: "海外市场",
        //   plate: 5
        // },
        // {
        //   link: "/page/table?plate=2&tableName=select_ylyjylcs",
        //   img: "static/images/api.png",
        //   imgActive: "static/images/api_a.png",
        //   title: "原料药供销",
        //   plate: 2
        // },
        // {
        //   link: "/page/download?plate=6&tableName=select_file@1",
        //   img: "static/images/ziliao.png",
        //   imgActive: "static/images/ziliao_a.png",
        //   title: "资料下载",
        //   plate: 6
        // },
        // {
        //   link: "/page/table?plate=1&tableName=select_yllssgsyj",
        //   img: "static/images/zhibiao.png",
        //   imgActive: "static/images/zhibiao_a.png",
        //   title: "指标查询",
        //   plate: 7
        // }
      ],
      active: [0, 0, 0, 0, 0, 0, 0,0],
      activePageList: [] //最后一级面包屑
    };
  },
  watch: {
    directory(val){

    }
  },
  mounted() {
    var _this = this;
    this.api
      .getTreeFirst()
      .then(res => {
        this.directory = res.plateList;
        this.activePageList = res.firstTitle;
        this.$nextTick(()=>{
          this.$set(this.active, this.activeIndex, 1);
        })
      })
      .catch(error => {});
  },
  methods: {
    normalizeTabImage(src) {
      if (!src) {
        return src;
      }
      if (/^(https?:)?\/\//.test(src) || /^data:/.test(src)) {
        return src;
      }
      var appBase = (window.cfg && window.cfg.appBase) || "/";
      if (appBase.charAt(appBase.length - 1) !== "/") {
        appBase += "/";
      }
      if (src.indexOf(appBase) === 0) {
        return src;
      }
      var normalizedSrc = src.charAt(0) === "/" ? src.slice(1) : src;
      return appBase + normalizedSrc;
    },
    setActive(index) {
      this.active = [0, 0, 0, 0, 0, 0, 0,0];
      this.$set(this.active, index, 1);
      this.$store.commit("SetActivePage", this.activePageList[index]);
      localStorage.removeItem('urlActiveName');
      localStorage.removeItem('urlActive');
      // let title="";
      // if(this.activeIndex!=-1){
      //   title=this.directory[this.activeIndex].title;
      // }
      // console.log(title);
      // this.$store.commit("SetActivePath",title);
    }
  },
  computed: {
    staticImageBase() {
      var appBase = (window.cfg && window.cfg.appBase) || "/";
      if (appBase.charAt(appBase.length - 1) !== "/") {
        appBase += "/";
      }
      return appBase + "static/images/";
    },
    activeIndex: function() {
      let activeList = this.directory.map(item => {
        return item.plate;
      });
      return activeList.indexOf(this.plate / 1);
    },
    isHome(){
      return this.$route.path === "/"
    }
    // ...mapState({
    //   plate: state => state.plate
    // }),
  }
};
</script>
<style lang="less" scoped>
@import "../styles/size.less";
@fz: 17px;
@wImg: 24px;
@fzHome: 22px;
@wImgHome: 32px;
.ul-wrapper {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  .li-item {
    border-right: 1px solid @dfdfdf;
    flex: 1;
    box-sizing: border-box;
    .son {
      line-height: 30px;//tttd 图片文字垂直居中
      text-align: center;
      img {
        width: @wImg;
        position: relative;
        top: -2px;
      }
      span {
        padding-left: 6px;
        font-size: @fz;
        line-height: @fz;
        color: @theme-color;
        &.isActive {
          color: #b7b7b7;
        }
      }
    }
  }
  li:last-child {
    border: 0;
  }
}
.ul-wrapper.home{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  margin-top: 30px;
  .li-item {
    border-right: 1px solid @dfdfdf;
    //width: 200px;
    box-sizing: border-box;
    .son {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: @wImgHome;
      }
      span {
        margin-top: 20px;
        font-size: @fzHome;
        line-height: @fzHome;
        color: @theme-color;
        &.isActive {
          color: #b7b7b7;
        }
      }
    }
  }
  li:last-child {
    border: 0;
  }
}
.router-link-active{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/common/tabs.vue